import api from "./api";

const route = "/course_purchases";

const CoursePurchasesService = {
  getCoursePurchases: () => api.get(route),
};
export default CoursePurchasesService;
